'use client';

import {Transition} from '@headlessui/react';
import React, {FC, PropsWithChildren, useEffect, useState} from 'react';
import ReactDOM from 'react-dom';

interface Props {
	prepend?: boolean;
	withBottomMargin?: boolean;
	fullWidth?: boolean;
	slide?: 'bottom';
}

export type ActionsAreaPortalProps = PropsWithChildren<Props>;

export const ActionsAreaPortal: FC<ActionsAreaPortalProps> = ({
	children,
	prepend,
	withBottomMargin,
	fullWidth,
	slide,
}) => {
	const [container, setContainer] = useState<HTMLDivElement>();

	useEffect(() => {
		const root = document.querySelector<HTMLDivElement>(`#action-area-slot`);

		if (!root) return;

		const container = document.createElement('div');
		container.classList.add('pointer-events-auto');

		if (fullWidth) container.classList.add('w-full');
		if (withBottomMargin) container.classList.add('mb-6');

		setContainer(container);

		prepend ? root.prepend(container) : root.append(container);

		return () => {
			root.removeChild(container);
		};
	}, []);

	if (!container) return null;

	if (slide === 'bottom')
		return ReactDOM.createPortal(
			<Transition
				appear={true}
				show={true}
				enter="transition-all ease-in-out duration-300"
				enterFrom="translate-y-full opacity-50 scale-y-95"
				enterTo="translate-y-0 opacity-100"
				leave="transition ease-in-out duration-300"
				leaveFrom="translate-y-0 opacity-100"
				leaveTo="translate-y-full opacity-0 scale-10"
			>
				{children}
			</Transition>,
			container,
		);

	return ReactDOM.createPortal(children, container);
};
